import { CallState } from "@b2bportal/core-types";
import { createSelector } from "@reduxjs/toolkit";
import type { CarsState } from "../../../store";

export const getCarShopState = (state: CarsState) => state.cars.carsShop;

export const getShopCallState = (state: CarsState) =>
  state.cars.carsShop.shopCallState;

export const getOpaqueShopRequestContext = (state: CarsState) =>
  state.cars.carsAvailability?.searchResult?.data?.context
    ?.opaqueShopRequestContext;

export const getSelectedVehicle = (state: CarsState) =>
  state.cars.carsShop.selectedVehicle;

export const getCarShop = (state: CarsState) => state.cars.carsShop.shop;

export const getShopData = createSelector(getCarShopState, (state) => {
  return {
    data: state.shop,
    isLoading: state.shopCallState === CallState.InProcess,
    isError: state.shopCallState === CallState.Failed,
  };
});
